var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import CModal from '../modal';
import Card from '../card';
import Button from '../button';
import Icon from '../icon';
import { fetchIntervals, fetchIntervalDetails, } from '../../../http/maintenance-schedules';
export default (props) => {
    const [severity, setSeverity] = React.useState('Normal');
    const [intervals, setIntervals] = React.useState(undefined);
    const [selectedInterval, setSelectedInterval] = React.useState(null);
    const [details, setDetails] = React.useState(undefined);
    const [error, setError] = React.useState(null);
    const loadIntervals = (sev) => __awaiter(void 0, void 0, void 0, function* () {
        setIntervals(null);
        setSelectedInterval(null);
        setDetails(undefined);
        setError(null);
        try {
            const data = yield fetchIntervals(props.merchantId, props.vin, sev);
            setIntervals(data);
        }
        catch (_a) {
            setIntervals({ intervals: [], intervalType: 'Miles' });
            setError('Failed to load maintenance schedule. This vehicle may not be supported.');
        }
    });
    const loadDetails = (intervalValue, intervalType) => __awaiter(void 0, void 0, void 0, function* () {
        setSelectedInterval(intervalValue);
        setDetails(null);
        try {
            const data = yield fetchIntervalDetails(props.merchantId, props.vin, severity, intervalValue, intervalType);
            setDetails(data);
        }
        catch (_a) {
            setDetails({ applications: [] });
        }
    });
    React.useEffect(() => {
        if (props.visible && props.vin) {
            loadIntervals(severity);
        }
        if (!props.visible) {
            setIntervals(undefined);
            setSelectedInterval(null);
            setDetails(undefined);
            setError(null);
        }
    }, [props.visible]);
    const onSeverityChange = (sev) => {
        setSeverity(sev);
        loadIntervals(sev);
    };
    const formatInterval = (val, type) => {
        const num = parseInt(val, 10);
        if (type === 'Months')
            return `${num.toLocaleString()} months`;
        return `${num.toLocaleString()} mi`;
    };
    const getIntervalStatus = (val) => {
        if (!props.odometer)
            return 'future';
        const num = parseInt(val, 10);
        if ((intervals === null || intervals === void 0 ? void 0 : intervals.intervalType) !== 'Miles')
            return 'future';
        if (num < props.odometer - 1000)
            return 'past';
        if (num <= props.odometer + 1000)
            return 'current';
        return 'future';
    };
    const formatLaborTime = (hours) => {
        if (!hours)
            return '\u2014';
        return `${hours.toFixed(1)} hrs`;
    };
    const printSummary = () => {
        if (!selectedInterval || !details || !intervals)
            return;
        const win = window.open('', '_blank');
        if (!win)
            return;
        const status = getIntervalStatus(selectedInterval);
        const statusLabel = status === 'past' ? ' (PAST)' : status === 'current' ? ' (DUE NOW)' : '';
        const rows = details.applications.map((app) => {
            var _a;
            return `
      <tr>
        <td style="padding:6px 8px;border-bottom:1px solid #ddd">${app.name}</td>
        <td style="padding:6px 8px;border-bottom:1px solid #ddd">${app.description || '\u2014'}</td>
        <td style="padding:6px 8px;border-bottom:1px solid #ddd;text-align:center">${app.all.laborTime ? app.all.laborTime.toFixed(1) + ' hrs' : '\u2014'}</td>
        <td style="padding:6px 8px;border-bottom:1px solid #ddd">${app.skill.name}</td>
        <td style="padding:6px 8px;border-bottom:1px solid #ddd;font-size:12px">${((_a = app.attributes) === null || _a === void 0 ? void 0 : _a.map((a) => a.text || a.name).join(', ')) || '\u2014'}</td>
      </tr>
      ${app.notes.length ? `<tr><td colspan="5" style="padding:2px 8px 6px;font-size:11px;color:#666;border-bottom:1px solid #ddd">Note: ${app.notes.join('; ')}</td></tr>` : ''}
    `;
        }).join('');
        win.document.write(`<!DOCTYPE html>
<html><head><title>Maintenance Schedule - ${props.vin}</title>
<style>
  body { font-family: Arial, sans-serif; margin: 20px 30px; color: #333; }
  h1 { font-size: 18px; margin-bottom: 4px; }
  .meta { font-size: 13px; color: #666; margin-bottom: 16px; }
  table { width: 100%; border-collapse: collapse; font-size: 13px; }
  th { text-align: left; padding: 8px; background: #f0f0f0; border-bottom: 2px solid #ccc; }
  @media print { body { margin: 10mm; } }
</style>
</head><body>
  <h1>Vehicle Maintenance Schedule</h1>
  <div class="meta">
    <strong>VIN:</strong> ${props.vin} &nbsp;&bull;&nbsp;
    <strong>Interval:</strong> ${formatInterval(selectedInterval, intervals.intervalType)}${statusLabel} &nbsp;&bull;&nbsp;
    <strong>Conditions:</strong> ${severity}
    ${props.odometer ? ' &nbsp;&bull;&nbsp; <strong>Odometer:</strong> ' + props.odometer.toLocaleString() + ' mi' : ''}
  </div>
  <table>
    <thead>
      <tr>
        <th>Service</th>
        <th>Description</th>
        <th style="text-align:center">Labor</th>
        <th>Skill</th>
        <th>Parts</th>
      </tr>
    </thead>
    <tbody>${rows}</tbody>
  </table>
  <div style="margin-top:20px;font-size:11px;color:#999">Printed ${new Date().toLocaleDateString()}</div>
<script>window.print()</script>
</body></html>`);
        win.document.close();
    };
    return _jsxs(CModal, { visible: props.visible, title: _jsxs(_Fragment, { children: ["Maintenance Schedule ", _jsx("span", { className: "text-muted fw-normal", style: { 'fontSize': '14px' }, children: props.title })] }), onClose: props.onClose, nofooter: true, xl: true, children: [_jsxs("div", { className: "mb-3 d-flex align-items-center gap-2", children: [_jsx("span", { className: "fw-semibold me-1", children: "Driving Conditions:" }), _jsxs("div", { className: "btn-group btn-group-sm", children: [_jsx("button", { type: "button", className: `btn ${severity === 'Normal' ? 'btn-primary' : 'btn-outline-secondary'}`, onClick: () => onSeverityChange('Normal'), children: "Normal" }), _jsx("button", { type: "button", className: `btn ${severity === 'Severe' ? 'btn-primary' : 'btn-outline-secondary'}`, onClick: () => onSeverityChange('Severe'), children: "Severe" })] }), !!props.odometer && (intervals === null || intervals === void 0 ? void 0 : intervals.intervalType) === 'Miles' && _jsxs("span", { className: "ms-auto text-muted", style: { 'fontSize': '13px' }, children: ["Current odometer: ", _jsxs("strong", { children: [props.odometer.toLocaleString(), " mi"] })] })] }), error && _jsx("div", { className: "alert alert-warning", children: error }), intervals === null && _jsx("div", { className: "text-center m-4", children: _jsx("div", { className: "spinner-border text-primary", role: "status", children: _jsx("span", { className: "visually-hidden", children: "Loading..." }) }) }), intervals && intervals.intervals.length === 0 && !error && _jsx("div", { className: "alert alert-info", children: "No maintenance schedule data available for this vehicle." }), intervals && intervals.intervals.length > 0 && _jsxs("div", { className: "row", children: [_jsx("div", { className: "col-4", children: _jsx(Card, { title: "Service Intervals", flush: true, children: _jsx("div", { className: "list-group list-group-flush", children: intervals.intervals.map((interval) => {
                                    const status = getIntervalStatus(interval);
                                    return _jsxs("button", { type: "button", className: `list-group-item list-group-item-action d-flex justify-content-between align-items-center ${selectedInterval === interval ? 'active' : ''}`, onClick: () => loadDetails(interval, intervals.intervalType), children: [_jsx("span", { children: formatInterval(interval, intervals.intervalType) }), status === 'past' && _jsx("span", { className: "badge bg-success", style: { 'fontSize': '10px' }, children: "PAST" }), status === 'current' && _jsx("span", { className: "badge bg-warning text-dark", style: { 'fontSize': '10px' }, children: "DUE" })] }, interval);
                                }) }) }) }), _jsxs("div", { className: "col-8", children: [!selectedInterval && _jsx("div", { className: "text-muted text-center mt-4", children: "Select an interval to view services" }), selectedInterval && details === null && _jsx("div", { className: "text-center m-4", children: _jsx("div", { className: "spinner-border text-primary", role: "status", children: _jsx("span", { className: "visually-hidden", children: "Loading..." }) }) }), selectedInterval && details && details.applications.length === 0 && _jsx("div", { className: "alert alert-info", children: "No services found for this interval." }), selectedInterval && details && details.applications.length > 0 && _jsxs(_Fragment, { children: [_jsxs("div", { className: "d-flex justify-content-between align-items-center mb-2", children: [_jsxs("h6", { className: "mb-0", children: ["Services at ", formatInterval(selectedInterval, intervals.intervalType)] }), _jsx(Button, { color: "secondary", onClick: printSummary, title: "Print Summary", children: _jsx(Icon, { size: "inherit", children: "print" }) })] }), _jsx("div", { className: "d-flex flex-column gap-2", children: details.applications.map((app) => _jsxs("div", { className: "border rounded p-2", style: { 'fontSize': '13px' }, children: [_jsxs("div", { className: "d-flex justify-content-between align-items-start mb-1", children: [_jsx("strong", { children: app.name }), _jsx("span", { className: "badge bg-secondary ms-2", style: { 'whiteSpace': 'nowrap' }, children: app.skill.name })] }), app.description && _jsx("div", { className: "text-muted mb-1", children: app.description }), _jsxs("div", { className: "d-flex gap-3", children: [_jsxs("span", { children: ["Labor: ", _jsx("strong", { children: formatLaborTime(app.all.laborTime) })] }), app.all.warrantyLaborTime > 0 && _jsxs("span", { className: "text-muted", children: ["Warranty: ", formatLaborTime(app.all.warrantyLaborTime)] }), app.taxonomy && _jsx("span", { className: "text-muted", children: app.taxonomy.name })] }), app.notes.length > 0 && _jsx("div", { className: "text-muted mt-1", style: { 'fontSize': '12px' }, children: app.notes.map((note, i) => _jsx("div", { children: note }, i)) }), app.attributes && app.attributes.length > 0 && _jsxs("div", { className: "mt-1", style: { 'fontSize': '12px' }, children: [_jsx("span", { className: "text-muted", children: "Parts: " }), app.attributes.map((attr) => attr.text || attr.name).join(', ')] })] }, app.applicationId)) })] })] })] })] });
};
